import type { SVGProps } from 'react'

export const CloseIcon: { __brand: 'color' | 'nocolor' } = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_7935_24)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00002 9.06066L11.4697 12.5303L12.5304 11.4697L9.06068 8L12.5304 4.53031L11.4697 3.46965L8.00002 6.93934L4.53034 3.46966L3.46968 4.53032L6.93936 8L3.46968 11.4697L4.53034 12.5303L8.00002 9.06066Z"
          fill="var(--color-icon-base-default, #707070)"
        />
      </g>
      <defs>
        <clipPath id="clip0_7935_24">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

CloseIcon.__brand = 'nocolor'
